import {
  DatePicker,
  Form,
  FormProps,
  Input,
  Modal,
  ModalProps,
  Select,
  useSelect,
} from '@pankod/refine-antd'
import dayjs from 'dayjs'
import React from 'react'
import locale from 'antd/lib/locale/id_ID'

import { PROGRAM_STATE } from '@resources/lms-management/program/types'

type EditProgramModalFormProps = {
  editModalProps: ModalProps
  editFormProps: FormProps
  onSubmit: () => Promise<any>
}

const EditProgramModalForm = ({
  editFormProps,
  editModalProps,
  onSubmit,
}: EditProgramModalFormProps) => {
  const { selectProps: tagSelectProps } = useSelect({
    resource: 'program-tags',
    dataProviderName: 'lms',
    filters: [{ field: 'pageSize', operator: 'eq', value: -1 }],
    optionLabel: 'name',
    optionValue: 'id',
    queryOptions: {
      enabled: !!editModalProps.visible,
    },
    defaultValueQueryOptions: {
      enabled: false,
    },
  })
  return (
    <Modal
      {...editModalProps}
      title="Ubah Program"
      okButtonProps={{
        onClick: async () => {
          const data = await onSubmit()
          editFormProps.onFinish?.(data)
        },
      }}
      destroyOnClose
      okText="Simpan"
      cancelText="Batal"
    >
      <Form
        {...editFormProps}
        initialValues={(() => {
          const {
            startDate,
            endDate,
            pendaftaranStartDate,
            pendaftaranEndDate,
            tags,
            ...rest
          } = editFormProps?.initialValues?.data || {}
          const periode = [dayjs(startDate), dayjs(endDate)]
          const periodePendaftaran =
            pendaftaranStartDate && pendaftaranEndDate
              ? [dayjs(pendaftaranStartDate), dayjs(pendaftaranEndDate)]
              : undefined

          return {
            ...rest,
            periode,
            periodePendaftaran,
            tags: tags?.map((tag: { id: number }) => tag.id) || [],
          }
        })()}
        layout="vertical"
        validateMessages={{ required: '${label} harus diisi.' }}
      >
        <Form.Item
          label="Nama"
          name="name"
          required
          rules={[{ required: true }]}
        >
          <Input
            autoComplete="off"
            disabled={
              (editFormProps as FormProps).form?.getFieldValue('status') !==
              PROGRAM_STATE.PREPARATION
            }
          />
        </Form.Item>
        <Form.Item label="Periode" name="periode" rules={[{ required: true }]}>
          <DatePicker.RangePicker
            format="DD MMM YYYY"
            locale={locale.DatePicker}
          />
        </Form.Item>
        <Form.Item label="Rentang Pendaftaran" name="periodePendaftaran">
          <DatePicker.RangePicker
            format="DD MMM YYYY"
            locale={locale.DatePicker}
            disabled={
              (editFormProps as FormProps).form?.getFieldValue('status') !==
              PROGRAM_STATE.PREPARATION
            }
          />
        </Form.Item>
        <Form.Item label="Tag" name="tags">
          <Select
            mode="multiple"
            {...tagSelectProps}
            onSearch={() => {}}
            filterOption={(input, option) =>
              (option!.label as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default EditProgramModalForm
